import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito saber inglés?',
    a: 'No, el sistema está diseñado para que uses herramientas gratuitas de traducción y plantillas listas en ambos idiomas.'
  }, {
    q: '¿Tengo que invertir en inventario?',
    a: 'Cero. Es un negocio de productos digitales; el cliente descarga el archivo y lo imprime él mismo.'
  }, {
    q: '¿Qué pasa si no soy creativa?',
    a: 'La IA es tu creatividad. Nosotros te damos los comandos para que ella haga el trabajo artístico por ti.'
  }];
  const [openIdx, setOpenIdx] = useState<number | null>(0);
  return <section className="py-16 md:py-24 bg-white px-4 sm:px-6 lg:px-8" data-id="element-44">
      <div className="max-w-3xl mx-auto" data-id="element-45">
        <FadeIn data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-center text-darkText mb-12" data-id="element-47">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, idx) => <FadeIn key={idx} delay={idx * 0.1} data-id="element-49">
              <div className={`border rounded-2xl overflow-hidden transition-colors ${openIdx === idx ? 'border-lavender bg-cream/30' : 'border-cream hover:border-lavender/50'}`} data-id="element-50">
                <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIdx(openIdx === idx ? null : idx)} data-id="element-51">
                  <span className="font-bold text-darkText pr-4" data-id="element-52">{faq.q}</span>
                  <ChevronDown className={`w-5 h-5 text-lightText transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`} data-id="element-53" />
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIdx === idx ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-54">
                  <p className="text-lightText" data-id="element-55">{faq.a}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}